// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { ErrorsComponent } from './errors.component';

/**
 * Routes
 */
const routes: Routes = [
  {path: '', component: ErrorsComponent}
];

/**
 * Errors Routing Module
 */
@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class ErrorsRoutingModule {
}
